<template>
  <app-toast class='add-bank-toast' :message='message'>
    <div class='toast-body' v-html='$t("accounts.add.added", {bankName: message.bank.name})'>
    </div>
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'add-bank',
    props: {
      message: Object
    },

    components: {
      'app-toast': appToast
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .add-bank-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
